// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"621":"ce2f21c7","743":"6cd9723e","917":"207494aa"}[chunkId] + ".chunk.js";
};